import { useState, useEffect } from 'react';
import { fetchRequest } from '$CONFIG/Fatch.config';

const useFooter = ({ url }) => {
    const [footerData, setFooterData] = useState({});

    useEffect(() => {
        const getFooter = () => {
            fetchRequest(url, 'GET').then(res => {
                if (res?.data) {
                    setFooterData(res.data)
                } else {
                    throw new Error()
                }
            }).catch(error => {
                console.log(error);
            })
        }

        getFooter();
    }, [url]);
    return footerData;
}

export default useFooter